import { UserRootState, UsersSingleState } from '@probatix/common/services/RTKServices/patients/index.model'

export const getSingleUserState = (state: UserRootState): UsersSingleState => state.user.single
